import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService, LoansService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';  


@Component({
  selector: 'app-paystackpayments',
  templateUrl: './paystackpayments.component.html',
  styleUrls: ['./paystackpayments.component.css']
})
export class PaystackpaymentsComponent implements OnInit {

  loading = false;
  start_date = '2022-07-20';
  end_date = '2022-07-21';
  customers:any;
  currentUser:any;
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService, public loansService: LoansService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) {
   this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getCyberpayPayments(); 
  }
  getCyberpayPayments() {

    this.loading = true;
    this.loansService.getPaystackPayments(this.start_date, this.end_date, this.currentUser.token)
      .subscribe(employee_performance => {
        this.loading = false;
        this.customers = employee_performance.data;
      });

  }

}
